import { render, staticRenderFns } from "./land-info.html?vue&type=template&id=a35b43c2&scoped=true&external"
import script from "./land-info.js?vue&type=script&lang=js&external"
export * from "./land-info.js?vue&type=script&lang=js&external"
import style0 from "./land-info.scss?vue&type=style&index=0&id=a35b43c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b43c2",
  null
  
)

export default component.exports